import { render, staticRenderFns } from "./VisitStatisticsCategoryMg.vue?vue&type=template&id=2fc45aae&scoped=true"
import script from "./VisitStatisticsCategoryMg.vue?vue&type=script&lang=js"
export * from "./VisitStatisticsCategoryMg.vue?vue&type=script&lang=js"
import style0 from "./VisitStatisticsCategoryMg.vue?vue&type=style&index=0&id=2fc45aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc45aae",
  null
  
)

export default component.exports